import { render, staticRenderFns } from "./page-select.vue?vue&type=template&id=056bbf2e"
import script from "./page-select.vue?vue&type=script&lang=js"
export * from "./page-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports